// @flow

import get from 'lodash/get'
import { type WizardLandingPage, DEFAULT_LANGUAGE, type WizardPage } from '@chatchamp/chatchamp-types'

import { DEFAULT_COLOR } from '../../common/defaultColor'
import { getProgressBarData } from '../../common/utils/progressBar'
import type { State } from './state'

export const getters = {
  primaryColor (state: State): string {
    return get(state.customerConfig, 'backgroundColor', DEFAULT_COLOR)
  },
  landingPage (state: State): WizardLandingPage {
    return state.wizard.landingPage
  },
  avatarImageUrl (state: State): string {
    return get(state.customerConfig, 'avatarImageUrl', '')
  },
  avatarName (state: State): string {
    return state.wizard.avatarName || get(state.customerConfig, 'avatarName', '')
  },
  logoUrl (state: State): string {
    return get(state.customerConfig, 'logoUrl', '')
  },
  productClickAction (state: State): string {
    return get(state.customerConfig, ['productClickAction'], 'openUrl')
  },
  isLandingPage (state: State): boolean {
    return state.isLandingPage
  },
  currentWizardPage (state: State): any {
    return state.wizardPages[state.wizardPageIndex]
  },
  wizardPages (state: State): Array<WizardPage> {
    return state.wizardPages
  },
  wizardPageIndex (state: State): number {
    return state.wizardPageIndex
  },
  selectedOptions (state: State): any {
    return state.selectedOptions
  },
  moreProductsAvailable (state: State): number {
    return state.recommendedProducts?.moreProductsAvailable || 0
  },
  moreProductsButtonTitle (state: State): any {
    return state.recommendedProducts?.moreProductsButtonTitle
  },
  isSortingEnabled (state: State): boolean {
    return !!state.recommendedProducts?.sortingEnabled
  },
  isSavingWizardPageAnswer (state: State): boolean {
    return state.isSavingWizardPageAnswer
  },
  wizardPageData (state: State): any {
    return state.wizardPageData
  },
  wizardPayload (state: State): any {
    return state.wizard.payload
  },
  locale (state: State): string {
    return get(state.customerConfig, 'locale', DEFAULT_LANGUAGE)
  },
  customCss (state: State): string {
    return get(state.wizard, ['customCss'], '')
  },
  isLastPage (state: State): boolean {
    // $FlowFixMe
    return !!state.wizardPageData?.isLastPage
  },
  progressBar (state: State, getters: any): any {
    return getProgressBarData(state.wizardPages, state.visitedPageIds, state.wizardPageIndex, getters.isLastPage)
  },
  isCurrentProductsPage (state: State, getters: any): boolean {
    return getters.currentWizardPage?.pageType === 'products'
  },
  isCurrentPageText (state: State, getters: any): boolean {
    return getters.currentWizardPage?.pageType === 'text'
  },
  isCurrentPageVideo (state: State, getters: any): boolean {
    return getters.currentWizardPage?.pageType === 'video'
  },
  isCurrentPageImage (state: State, getters: any): boolean {
    return getters.currentWizardPage?.pageType === 'image'
  },
  isAnyOptionSelectedForCurrentPage (state: State, getters: any): boolean {
    if (getters.currentWizardPage && getters.selectedOptions[getters.currentWizardPage.id]) {
      return getters.selectedOptions[getters.currentWizardPage.id].length > 0
    }
    return false
  },
  isCurrentPageOptional (state: State, getters: any): boolean {
    return !!getters.currentWizardPage?.optional
  },
  isCurrentPageRange (state: State, getters: any): boolean {
    return getters.currentWizardPage?.pageType === 'range'
  },
  isCurrentPageInput (state: State, getters: any): boolean {
    return getters.currentWizardPage?.pageType === 'input'
  },
  isSearchEnabled (state: State, getters: any): boolean {
    return ['single_choice', 'multiple_choice'].includes(getters.currentWizardPage?.pageType) && getters.wizardPageData?.options?.length >= 10
  },
  chatchampLinkClickable (state: State): boolean {
    return get(state.customerConfig, 'chatchampLinkClickable', false)
  },
  isEnabledAddToCart (state: State): boolean {
    return get(state.customerConfig, 'isEnabledAddToCart', false)
  }
}
